import * as React from 'react';
import { ArticleHeading4, ArticleParagraph1 } from '@cian/ui-kit';

import { IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './NewbuildingLinksList.css';
import { IPromoPopupNewbuildingLink } from '../../../../types/specialPromos/promoPopup';

interface INewbuildingLinksListProps {
  newbuildingCountLink?: string;
  newbuildingCountText: string;
  newbuildingLinks: IPromoPopupNewbuildingLink[];
}

export const NewbuildingLinksList: React.FC<INewbuildingLinksListProps> = ({
  newbuildingCountLink,
  newbuildingCountText,
  newbuildingLinks,
}) => {
  return (
    <>
      <div className={styles['title']}>
        {newbuildingCountLink ? (
          <a
            href={newbuildingCountLink}
            className={styles['title-link']}
            target="_blank"
            rel="noreferrer"
            data-testid="NewbuildingListLink"
          >
            <ArticleParagraph1 color="text-main-default">{newbuildingCountText}</ArticleParagraph1>
          </a>
        ) : (
          <ArticleHeading4 color="text-primary-default">{newbuildingCountText}</ArticleHeading4>
        )}
      </div>
      <ul className={styles['list']}>
        {newbuildingLinks.map((link, idx) => (
          <li key={idx} className={styles['list-item']}>
            <a
              href={link.url}
              className={styles['link']}
              target="_blank"
              rel="noreferrer"
              data-testid="NewbuildingListItemLink"
            >
              <ArticleParagraph1>{link.name}</ArticleParagraph1>
              <IconActionChevronRight16 />
            </a>
          </li>
        ))}
      </ul>
    </>
  );
};
